import React, { FC } from 'react';
import { Snack } from 'fronton-react';
import { t } from 'i18next';

type Props = {
  id: string;
};

export const OnlineOrderErrorNotification: FC<Props> = ({ id }) => (
  <Snack
    key={id}
    id={id}
    variant="error"
    header={t('ui.snackbar.online-order-error-header')}
    paragraph={t('ui.snackbar.online-order-error-paragraph')}
    autoHideTimer={5000}
  />
);
